export const popupOptions = {
  anchor: 'bottom',
  closeButton: false,
  maxWidth: '400px',
  offset: {
    'bottom': [0, -20]
  }
}
